import React from "react";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import { makeStyles, withStyles } from "@material-ui/core/styles";

export const TblBodyCell = withStyles((theme) => ({
  head: {
    backgroundColor: "rgba(255, 255, 255, 0.92)",
    color: "rgba(107, 114, 128, 1)",
    fontSize: "12px",
    lineHeight: "16px",
    fontWeight: 500,
  },
  body: {
    fontSize: 14,
    background: "white",
  },
}))(TableCell);

const useStyles = makeStyles({
  container: {
    "&::-webkit-scrollbar": {
      width: "4px",
      borderRadius: "10px",
      backgroundColor: "rgba(0,0,0,0)",
    },
    "&::-webkit-scrollbar-track": {
      boxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
      webkitBoxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "rgba(0,0,0,.3)",
      outline: "1px solid rgba(0,0,0,0.1)",
      borderRadius: "10px",
    },
  },
  table: {},
  title: {
    fontSize: "1.828em",
    lineHeight: "1.5em",
    letterSpacing: "0.05625px",
    color: "rgba(63, 69, 79, 1)",
    margin: 0,
    marginBottom: "0.625em",
    fontWeight: 600,
  },
});

export const TblHead = TableHead;
export const TblHeadRow = TableRow;
export const TblHeadCell = TblBodyCell;
export const TblBody = TableBody;
export const TblBodyRow = withStyles((theme) => ({
  root: {},
}))(TableRow);

export const Tbl = (
  props: React.PropsWithChildren<{ width?: string; maxHeight?: string }>
) => {
  const classes = useStyles();
  return (
    <TableContainer
      style={{
        width: props.width,
        maxHeight: props.maxHeight,
        borderRadius: "20px",
      }}
      className={classes.container}
    >
      <Table
        stickyHeader
        style={{ tableLayout: "auto", width: "100%" }}
        className={classes.table}
        aria-label="customized table"
      >
        {props.children}
      </Table>
    </TableContainer>
  );
};
